export const HOST = process.env.NODE_ENV === 'production' ? "https://ibermis.org" : "http://invasaqua.anet.com.es"
export const API_URL = "/api"
